import { DocLayout } from './DocLayout';

export default function DocActivitatileMele() {
  return (
    <DocLayout title="Activitățile mele">
      <h2>Prezentare generală</h2>
      <p>
        Această pagină afișează activitățile la care organizația ta este listată ca prieten organizator.
        Poți vizualiza detaliile, edita informațiile și accesa listele de participanți.
      </p>

      <h2>Lista activități</h2>
      <p>Tabelul afișează:</p>
      <ul>
        <li><strong>Titlu</strong> — click pentru a edita activitatea.</li>
        <li><strong>Data</strong> — data și ora de start.</li>
        <li><strong>Locație</strong> — locul desfășurării.</li>
        <li><strong>Înscriși</strong> — numărul de participanți (ex: 12/50). Apare doar pentru activitățile cu înregistrare internă.</li>
        <li><strong>Status</strong> — Publicat sau Draft.</li>
        <li><strong>Participanți</strong> — buton de acces la lista de participanți (doar pentru activitățile cu înregistrare internă).</li>
      </ul>

      <h2>Editare activitate</h2>
      <p>
        Poți modifica informațiile activității (descriere, locație, date, tag-uri, contacte, setări de înregistrare).
        Publicarea și retragerea activităților este gestionată exclusiv de echipa staff.
      </p>

      <h2>Lista de participanți</h2>
      <p>
        Ca prieten, ai acces la lista de participanți pentru activitățile tale.
        Dacă organizația ta este <strong>validată</strong> (date legale complete + DPA semnat),
        vezi datele complete ale participanților. Dacă nu, datele personale sunt ascunse
        și funcțiile de printare și export nu sunt disponibile.
      </p>
      <p>
        Consultă <a href="/staff/documentatie/dpa">documentația DPA</a> pentru detalii despre procesul de validare.
      </p>
    </DocLayout>
  );
}
